import { Controller } from "@hotwired/stimulus";
import { startCase } from "lodash";

// Connects to data-controller="location-blueprint"
export default class extends Controller {
  static targets = ["fieldsTemplate", "fields"];
  static values = {
    blueprints: Object,
  };

  handle_settings({ target, params }) {
    let settings = this.blueprintsValue[target.value].settings_blueprint;

    if (settings.host_input) {
      settings.host_input.forEach((input) => {
        this.fieldsTarget.insertAdjacentHTML(
          "afterend",
          this.fieldsTemplateTarget.innerHTML
            .replaceAll("NAME", input)
            .replaceAll("LABEL", startCase(input)),
        );
      });
    }
  }
}
